function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "balance-scale",
  transform: "translate(-1.125 -6.117)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11588",
  "data-name": "Path 11588",
  d: "M14.291,27.17l.334-.368V24.989L9.149,13.43H6.6L1.125,24.989v1.9l.3.323a8.743,8.743,0,0,0,6.414,2.811h.03a8.743,8.743,0,0,0,6.424-2.855Zm-1.916-1.252a6.393,6.393,0,0,1-4.516,1.857H7.836a6.392,6.392,0,0,1-4.461-1.783v-.5l4.5-9.5,4.5,9.5Z",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11589",
  "data-name": "Path 11589",
  d: "M29.4,13.43H26.85L21.375,24.989v1.9l.3.323a8.743,8.743,0,0,0,6.414,2.811h.03a8.743,8.743,0,0,0,6.424-2.855l.334-.368V24.989Zm3.226,12.488a6.393,6.393,0,0,1-4.516,1.857h-.023a6.392,6.392,0,0,1-4.461-1.783v-.5l4.5-9.5,4.5,9.5Z",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11590",
  "data-name": "Path 11590",
  d: "M19.125,13.828a3.953,3.953,0,0,0,2.648-2.648H29.25V8.93H21.773a3.937,3.937,0,0,0-7.546,0H6.75v2.25h7.477a3.953,3.953,0,0,0,2.648,2.648V32.555H9.563v2.25H26.438v-2.25H19.125Zm-2.812-3.773A1.688,1.688,0,1,1,18,11.743a1.688,1.688,0,0,1-1.688-1.688Z",
  fill: "#ac1ede"
}));

var SvgBalanceScale = function SvgBalanceScale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.75,
    height: 28.688,
    viewBox: "0 0 33.75 28.688",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBalanceScale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/balance-scale.6ab61aaa.svg";
export { ForwardRef as ReactComponent };